/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompanyMemberResource } from './';
import {
    ClientCompanyMemberResourceFromJSON,
    ClientCompanyMemberResourceFromJSONTyped,
    ClientCompanyMemberResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface PageClientCompanyMemberResource
 */
export interface PageClientCompanyMemberResource {
    /**
     * 
     * @type {Array<ClientCompanyMemberResource>}
     * @memberof PageClientCompanyMemberResource
     */
    content: Array<ClientCompanyMemberResource>;
    /**
     * The total number of elements (not considering pagination)
     * @type {number}
     * @memberof PageClientCompanyMemberResource
     */
    totalElements: number;
    /**
     * True if the current page is the first page
     * @type {boolean}
     * @memberof PageClientCompanyMemberResource
     */
    first: boolean;
    /**
     * True if the current page is the last available page
     * @type {boolean}
     * @memberof PageClientCompanyMemberResource
     */
    last: boolean;
    /**
     * The number of elements of the current page (at most the page size)
     * @type {number}
     * @memberof PageClientCompanyMemberResource
     */
    numberOfElements: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageClientCompanyMemberResource
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the PageClientCompanyMemberResource interface.
 */
export function instanceOfPageClientCompanyMemberResource(value: object): value is PageClientCompanyMemberResource {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('first' in value) || value['first'] === undefined) return false;
    if (!('last' in value) || value['last'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    return true;
}

export function PageClientCompanyMemberResourceFromJSON(json: any): PageClientCompanyMemberResource {
    return PageClientCompanyMemberResourceFromJSONTyped(json, false);
}

export function PageClientCompanyMemberResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageClientCompanyMemberResource {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(ClientCompanyMemberResourceFromJSON)),
        'totalElements': json['totalElements'],
        'first': json['first'],
        'last': json['last'],
        'numberOfElements': json['numberOfElements'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function PageClientCompanyMemberResourceToJSON(value?: PageClientCompanyMemberResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': ((value['content'] as Array<any>).map((v) => ClientCompanyMemberResourceToJSON(v))),
        'totalElements': value['totalElements'],
        'first': value['first'],
        'last': value['last'],
        'numberOfElements': value['numberOfElements'],
        'empty': value['empty'],
    };
}

